import { Station } from './StationModel';
import { LuggageOption } from './LuggageOption';

export class SearchData {
  from: Station;
  to: Station;
  date: Date;
  returnTicket: boolean;
  personNumber: number;
  specialBooking: boolean;
  directOnly: boolean;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.from = new Station(data.from);
      this.to = new Station(data.to);
    }
  }
}

export class SearchDataDto {
  fromStationId: string;
  toStationId: string;
  fromTime: string;
  toTime: string;
  // tslint:disable-next-line:variable-name
  sale_channel: any;
  seatsCount: number;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class SearchDataGroup {
  searchResult: SearchResult;
  isSegmented: boolean;
  segmentedDrives: SearchResult[];

  get areSeatsNumberedOnSomeDrive() {
    return this.segmentedDrives.some(({ areSeatsNumbered }) => areSeatsNumbered);
  }

  constructor(data?: any, searchData?: SearchData) {
    if (data) {
      this.segmentedDrives = data.map(value => new SearchResult(value));
      this.isSegmented = data && data.length > 1 ? true : false;
      this.searchResult = this.setSearchResult(data, searchData);
    }
  }

  setSearchResult(data, searchData: SearchData) {

    let searchResult = new SearchResult(data[0]);
    if (this.isSegmented) {
      // from
      searchResult.fromStationName = searchData.from.stationName;
      searchResult.fromStationId = searchData.from.stationId + '';
      // to
      searchResult.toStationName = searchData.to.stationName;
      searchResult.toStationId = searchData.to.stationId + '';

      let price = 0;
      let kmTotal = 0;
      let minAvailableSeats = -1;
      for (const item of this.segmentedDrives) {
        price += item.price;
        kmTotal += item.kmTotal;
        minAvailableSeats = (minAvailableSeats > item.availableSeats || minAvailableSeats === -1) ? item.availableSeats : minAvailableSeats;
      }
      searchResult.price = price;
      searchResult.availableSeats = minAvailableSeats;
      searchResult.kmTotal = kmTotal;
      searchResult.departureTime = this.segmentedDrives[0].departureTime;
      searchResult.arrivalTime = this.segmentedDrives[this.segmentedDrives.length - 1].arrivalTime;
    }
    searchResult.price = searchData.returnTicket ? searchResult.price * 2 : searchResult.price;
    return searchResult;

  }

}

export class SearchResult {
  tripId: string;
  fromStationId: string;
  fromStationName: string;
  toStationId: string;
  toStationName: string;
  routeName: string;
  segmentCount: number;
  departurePlatform?: any;
  departureTime: Date;
  arrivalTime: Date;
  availableSeats: number;
  price?: any;
  carrierShortCode: string;
  carrierShortName: string;
  carrierVATNo: string;
  priority?: any;
  kmTotal: number;
  kmDomestic: number;
  commentTitle?: any;
  commentText?: any;
  posOptions?: any;
  internetOptions?: any;
  internetHoursToDepartureMin?: any;
  internetTicketType?: any;
  returnTripOptions?: any;
  isPriceFromMatrix: boolean;
  zoneName: string;
  carrierLogoUUID: string;
  areSeatsNumbered: boolean;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class CreateReservationsResponse {

  luggage: LuggageOption;
  reservationId: number;
  seatDesignation: string;
  seatId: number;
  price?: Price;
  firstName?: string;
  lastName?: string;
  phone?: string;
  documentId?: string;
  finished?: boolean;
  confirmed?: boolean;
  agencyTicketId: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      this.price = new Price();
    }
  }
}

export class Price {
  priceId: string;
  ticketTypeId: string;
  ticketTypeName: string;
  passengerCategoryId: number;
  returnTrip: boolean;
  returnTripLastDate: Date;
  defaultPrice: boolean;
  segment: PriceSegment[] = [];
  reservationId?: number;

  get ruleName() {
    return this.segment.map(({ ruleName }) => ruleName).join(', ');
  }

  get priceValue() {
    return this.segment.reduce((result, segment) => result + segment.priceValue, 0);
  }

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
      // normalize to undefined
      if (this.reservationId === null) {
        this.reservationId = undefined;
      }
      this.returnTripLastDate = new Date(data.returnTripLastDate);
      this.segment = data.segment.map(priceSegment => new PriceSegment(priceSegment));
    }
  }
}

class PriceSegment {
  priceId: string;
  price: string;
  priceTypeString: string;
  seats: string;
  ruleName: string;
  flexPrice: boolean;
  flexSeatNumbers: string[];
  zoneId: number;
  matrixPriceId: number;
  flexItemId: number;
  segmentNumber: number;

  get priceValue() {
    const priceNormalized = this.price.replace(',', '.');
    return parseFloat(priceNormalized);
  }

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/SearchData.ts